// extracted by mini-css-extract-plugin
module.exports = {"container":"BigTitle_container__26FZg","center":"BigTitle_center__1blHl"};